// =============================================
// SERVICIO DE BANCOS
// Obtiene el catálogo de bancos disponibles
// =============================================

import api from './api';

const bankService = {
  // Obtener todos los bancos
  getAllBanks: async () => {
    const response = await api.get('/banks');
    return response.data;
  },

  // Obtener solo bancos activos
  getActiveBanks: async () => {
    const response = await api.get('/banks/active');
    return response.data;
  },
};

export default bankService;
